export const setRoomName = (name) => ({
	type: 'SET_ROOM_NAME',
	payload: { name }
});

export const setRoomState = (state) => ({
	type: 'SET_ROOM_STATE',
	payload: { state }
});

export const setRoomActiveSpeaker = (peerId) => ({
	type: 'SET_ROOM_ACTIVE_SPEAKER',
	payload: { peerId }
});

export const setInLobby = (inLobby) => ({
	type: 'SET_IN_LOBBY',
	payload: { inLobby }
});

export const setSignInRequired = (signInRequired) => ({
	type: 'SET_SIGN_IN_REQUIRED',
	payload: { signInRequired }
});

export const setOverRoomLimit = (overRoomLimit) => ({
	type: 'SET_OVER_ROOM_LIMIT',
	payload: { overRoomLimit }
});

export const setAccessCode = (accessCode) => ({
	type: 'SET_ACCESS_CODE',
	payload: { accessCode }
});

export const setJoinByAccessCode = (joinByAccessCode) => ({
	type: 'SET_JOIN_BY_ACCESS_CODE',
	payload: { joinByAccessCode }
});

export const setRolesManagerOpen = (rolesManagerOpen) => ({
	type: 'SET_ROLES_MANAGER_OPEN',
	payload: { rolesManagerOpen }
});

export const setRolesManagerPeer = (rolesManagerPeer) => ({
	type: 'SET_ROLES_MANAGER_PEER',
	payload: { rolesManagerPeer }
});

export const setFileSharingSupported = (supported) => ({
	type: 'FILE_SHARING_SUPPORTED',
	payload: { supported }
});

export const setDisplayMode = (mode) => ({
	type: 'SET_DISPLAY_MODE',
	payload: { mode }
});

export const addSelectedPeer = (peerId) => ({
	type: 'ADD_SELECTED_PEER',
	payload: { peerId }
});

export const removeSelectedPeer = (peerId) => ({
	type: 'REMOVE_SELECTED_PEER',
	payload: { peerId }
});

export const setStartTime = (startTime) => ({
	type: 'SET_START_TIME',
	payload: { startTime }
});

export const setTimeLimit = (timeLimit) => ({
	type: 'SET_TIME_LIMIT',
	payload: { timeLimit }
});

export const clearSelectedPeers = () => ({
	type: 'CLEAR_SELECTED_PEERS'
});

export const setSpotlights = (spotlights) => ({
	type: 'SET_SPOTLIGHTS',
	payload: { spotlights }
});

export const clearSpotlights = () => ({
	type: 'CLEAR_SPOTLIGHTS'
});

export const toggleJoined = () => ({
	type: 'TOGGLE_JOINED'
});

export const toggleFullscreen = ({ consumerId, producerId }) => ({
	type: 'TOGGLE_FULLSCREEN',
	payload: { consumerId, producerId }
});

export const setLobbyPeersPromotionInProgress = (flag) => ({
	type: 'SET_LOBBY_PEERS_PROMOTION_IN_PROGRESS',
	payload: { flag }
});

export const toggleConsumerWindow = (consumerId) =>
	({
		type: 'TOGGLE_WINDOW_CONSUMER',
		payload: { consumerId }
	});

export const setMuteAllInProgress = (flag) => ({
	type: 'MUTE_ALL_IN_PROGRESS',
	payload: { flag }
});

export const setActiveQA = (flag) => ({
	type: 'ACTIVE_QA',
	payload: { flag }
});

export const setInactiveQA = (flag) => ({
	type: 'INACTIVE_QA',
	payload: { flag }
});

export const setMutedAll = (flag) => ({
	type: 'MUTE_ALL',
	payload: { flag }
});

export const setStopAllVideoInProgress = (flag) => ({
	type: 'STOP_ALL_VIDEO_IN_PROGRESS',
	payload: { flag }
});

export const setStopAllScreenSharingInProgress = (flag) => ({
	type: 'STOP_ALL_SCREEN_SHARING_IN_PROGRESS',
	payload: { flag }
});

export const setCloseMeetingInProgress = (flag) => ({
	type: 'CLOSE_MEETING_IN_PROGRESS',
	payload: { flag }
});

export const setClearChatInProgress = (flag) => ({
	type: 'CLEAR_CHAT_IN_PROGRESS',
	payload: { flag }
});

export const setClearFileSharingInProgress = (flag) => ({
	type: 'CLEAR_FILE_SHARING_IN_PROGRESS',
	payload: { flag }
});

export const setRoomWhiteboardSketch = (sketch) => ({
	type: 'SET_ROOM_WHITEBOARD_SKETCH',
	payload: { sketch }
});

export const setRoomPermissions = (roomPermissions) => ({
	type: 'SET_ROOM_PERMISSIONS',
	payload: { roomPermissions }
});

export const setUserRoles = (userRoles) => ({
	type: 'SET_USER_ROLES',
	payload: { userRoles }
});

export const setAllowWhenRoleMissing = (allowWhenRoleMissing) => ({
	type: 'SET_ALLOW_WHEN_ROLE_MISSING',
	payload: { allowWhenRoleMissing }
});

export const setHideSelfView = (hideSelfView) => ({
	type: 'SET_HIDE_SELF_VIEW',
	payload: { hideSelfView }
});

export const setRoomRecordingStatus = (recording) => ({
	type: 'SET_RECORDING_STATUS',
	payload: { recording }
});

export const setActiveWhiteboard = (active) => ({
	type: 'ACTIVE_WHITEBOARD',
	payload: { active }
});

export const setEmojiWebinar = (emoji) => ({
	type: 'SET_EMOJI_WEBINAR',
	payload: { emoji }
});

export const setRoomForceClose = () => ({
	type: 'SET_ROOM_FORCE_CLOSE'
});

export const setRoomKicked = () => ({
	type: 'SET_ROOM_KICKED'
});

export const setParentId = (parentId) => ({
	type: 'SET_PARENT_ID',
	payload: { parentId }
});

export const setRoomId = (roomId) => ({
	type: 'SET_ROOM_ID',
	payload: { roomId }
});

export const setUsersIntoWaiting = (roomId, waitingUsers) => ({
	type: 'SET_USER_INTO_WAITING',
	payload: { roomId, waitingUsers }
});

export const addUserIntoWaiting = (roomId, user) => ({
	type: 'ADD_USER_INTO_WAITING',
	payload: { roomId, user }
});

export const removeUsersFromWaiting = (userId) => ({
	type: 'REMOVE_USER_FROM_WAITING',
	payload: { userId }
});

export const setOpenChat = (openChat) => ({
	type: 'SET_OPEN_CHAT',
	payload: { openChat }
});

export const setActiveChat = (roomId, activeChat) => ({
	type: 'SET_ACTIVE_CHAT',
	payload: { roomId, activeChat }
});

export const setChatReceivers = (receivers) => ({
	type: 'SET_CHAT_RECEIVERS',
	payload: { chatReceivers: receivers }
});

export const setActiveCC = (flag) => ({
	type: 'ACTIVE_CC',
	payload: { flag }
});